<template>
  <div class="faq-container">
    <div class="faq-banner hidden-xs-only">
      <h1>Preguntas frecuentes</h1>
    </div>
    <div class="breadcrumb hidden-xs-only">
      <el-breadcrumb separator-class="icon-bullet-icon">
        <el-breadcrumb-item :to="{ name: 'home' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>Preguntas frecuentes</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="grid-container">
      <el-row
        class="grid-content">
        <el-col
          v-show="showTheme"
          :xs="24"
          :sm="9"
          :md="9"
          :lg="9"
          :xl="9"
          class="sticky">
          <div class="hidden-sm-and-up menu-responsive">
            <div class="breadcrumb">
              <el-breadcrumb separator-class="icon-bullet-icon">
                <el-breadcrumb-item :to="{ name: 'home' }">Home</el-breadcrumb-item>
                <el-breadcrumb-item>Preguntas frecuentes</el-breadcrumb-item>
              </el-breadcrumb>
            </div>
            <h1>Preguntas frecuentes</h1>
            <el-input
              placeholder="Buscar un tema">
              <i
                slot="prefix"
                class="icon-search-icon"/>
            </el-input>
          </div>
          <el-row>
            <div
              v-scroll-to="{element: '#one', offset: -100}"
              class="themes"
              @click="goToOne">
              <h1>{{ themes[0].titleTheme }}</h1>
              <p>{{ themes[0].textTheme }}</p>
            </div>

            <div
              v-scroll-to="{element: '#two', offset: -100}"
              class="themes"
              @click="goToTwo">
              <h1>{{ themes[1].titleTheme }}</h1>
              <p>{{ themes[1].textTheme }}</p>
            </div>
            <div
              v-scroll-to="{element: '#three', offset: -100}"
              class="themes"
              @click="goToThree">
              <h1>{{ themes[2].titleTheme }}</h1>
              <p>{{ themes[2].textTheme }}</p>
            </div>
            <div
              v-scroll-to="{element: '#four', offset: -100}"
              class="themes"
              @click="goToFour">
              <h1>{{ themes[3].titleTheme }}</h1>
              <p>{{ themes[3].textTheme }}</p>
            </div>
          </el-row>
        </el-col>
        <el-col
          :xs="24"
          :sm="14"
          :md="14"
          :lg="14"
          :xl="14"
          :offset="1"
          class="col-content">
          <theme-one id="one"/>
          <theme-two id="two"/>
          <theme-three id="three"/>
          <theme-four id="four"/>
        </el-col>
        <el-col
          v-show="showTheOne">
          <div class="back-to-faq">
            <i
              class="icon-arrow-left"
              @click="goToBack"/>
            <span>Preguntas frecuentes</span>
          </div>
          <theme-one/>
        </el-col>
        <el-col v-show="showTheTwo">
          <div class="back-to-faq">
            <i
              class="icon-arrow-left"
              @click="goToBack"/>
            <span>Preguntas frecuentes</span>
          </div>
          <theme-two/>
        </el-col>
        <el-col v-show="showTheThree">
          <div class="back-to-faq">
            <i
              class="icon-arrow-left"
              @click="goToBack"/>
            <span>Preguntas frecuentes</span>
          </div>
          <theme-three/>
        </el-col>
        <el-col v-show="showTheFour">
          <div class="back-to-faq">
            <i
              class="icon-arrow-left"
              @click="goToBack"/>
            <span>Preguntas frecuentes</span>
          </div>
          <theme-four/>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ThemeOne from './general-theme-one'
import ThemeTwo from './general-theme-two'
import ThemeThree from './general-theme-three'
import ThemeFour from './general-theme-four'
export default {
  name: 'Faq',
  components: {
    ThemeOne,
    ThemeTwo,
    ThemeThree,
    ThemeFour
  },
  data () {
    return {
      windowWidth: 0,
      block: 'block',
      none: 'none',
      showTheme: true,
      showTheOne: false,
      showTheTwo: false,
      showTheThree: false,
      showTheFour: false,
      themes: [
        {
          id: 1,
          titleTheme: 'Tema general1',
          textTheme: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuentes y legales.',
          path: 'generalOne'
        },
        {
          id: 2,
          titleTheme: 'Tema general2',
          textTheme: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuentes y legales.',
          path: 'generalTwo'
        },
        {
          id: 2,
          titleTheme: 'Tema general3',
          textTheme: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuentes y legales.',
          path: 'generalThree'
        },
        {
          id: 4,
          titleTheme: 'Tema general4',
          textTheme: 'Aquí una breve descripción de éste apartado, aplica para preguntas frecuentes y legales.',
          path: 'generalFour'
        }
      ]
    }
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
    if (this.$route.name === 'generalOne') {
      this.showTheme = false
      this.showTheOne = true
    }
    if (this.$route.name === 'generalTwo') {
      this.showTheme = false
      this.showTheTwo = true
    }
    if (this.$route.name === 'generalThree') {
      this.showTheme = false
      this.showTheThree = true
    }
    if (this.$route.name === 'generalFour') {
      this.showTheme = false
      this.showTheFour = true
    }
  },
  methods: {
    goToBack () {
      this.$router.push({name: 'faq'})
      this.showTheme = !this.showTheme
      this.showTheOne = false
      this.showTheTwo = false
      this.showTheThree = false
      this.showTheFour = false
    },
    /// ////////////////////////////////////////////////
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },
    /// ////////////////////////////////////////////////
    goToOne () {
      this.$router.push({name: 'generalOne'})
      if (this.windowWidth <= 414) {
        this.showTheOne = !this.showTheOne
        this.showTheme = !this.showTheme
        this.block = this.none
      }
    },
    goToTwo () {
      this.$router.push({name: 'generalTwo'})
      if (this.windowWidth <= 414) {
        this.showTheTwo = !this.showTheTwo
        this.showTheme = !this.showTheme
        this.block = this.none
      }
    },
    goToThree () {
      this.$router.push({name: 'generalThree'})
      if (this.windowWidth <= 414) {
        this.showTheThree = !this.showTheThree
        this.showTheme = !this.showTheme
        this.block = this.none
      }
    },
    goToFour () {
      this.$router.push({name: 'generalFour'})
      if (this.windowWidth <= 414) {
        this.showTheFour = !this.showTheFour
        this.showTheme = !this.showTheme
        this.block = this.none
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .block{
    display: block;
  }
  .sticky{
    position: sticky;
    top: 100px;
    @media #{$Elementxs} {
      position: relative;
      top: 0;
    }
  }
  .faq-container{
    margin-top: 70px;
    @media #{$iPhoneLandscape} {
      margin-top: 50px;
    }
  }
  .faq-banner{
    height: 300px;
    background-image: url("/static/images/faq.png");
    background-size: cover;
    background-position: center;
    position: relative;
    h1{
      position: absolute;
      margin: 0;
      @include font-primary(36px, light);
      color:white;
      bottom: 30px;
      left: 30px;
    }
  }
  .themes{
    height: 100px;
    background-color: white;
    padding: 20px;
    margin-bottom: 20px;
    transition: all .3s ease-in-out;
    cursor: pointer;
    @media #{$Note} {
      margin-bottom: 0;
      border-top: 1px solid #E3E6EA;
    }
    &:last-child{
      margin-bottom: 0;
    }
    &:hover{
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1), inset 3px 0 0 0 $roseHeader;
      @media #{$iPhone} {
        box-shadow: none;
        background-color: #F5F5F5;
      }
    }
    &:active{
      box-shadow: none;
      @media #{$iPhone} {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1), inset 3px 0 0 0 $roseHeader;
      }
    }
    h1{
      color: $dove;
      margin: 0;
      @include font-primary(16px, semibold)
    }
    p{
      color: $dove;
      @include font-primary(12px, regular)
    }
  }
  .aq-content{
    background-color: white;
    padding: 40px;
    margin-bottom: 20px;
    .title-aq{
      h1{
        @include font-primary(20px, semibold);
        color: $carbon
      }
      p{
        @include font-primary(14px, regular);
        color: $dove
      }
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
  /////////////RESPONSIVE DESIGN////////////////
  .grid-container{
    @media #{$Note} {
      padding: 0;
    }
    .grid-content{
      @media #{$Note} {
        padding: 0;
        width: 100%;
      }
    }
  }
  .menu-responsive {
    background-color: white;
    padding: 0 20px 20px 20px;
    @media #{$iPhone} {
      margin-bottom: 0;
    }
    h1{
      @include font-primary(28px, light);
      margin: 0;
      margin-bottom: 18px;
      color: #444444;
    }
    .el-input__inner {
      .el-input__prefix {
        top: 10px !important;
      }
    }
  }
  .col-content{
    @media #{$Note} {
      display: none;
    }
    @media #{$Elementxs} {
      margin-left: 0 !important;
      margin-top: 30px;
    }
    @media #{$iPhone} {
      margin-left: 0 !important;
      margin-top: 0;

    }
  }
  .back-to-faq{
    width: 100%;
    background-color: #C84B59;
    color: white;
    height: 35px;
    display: flex;
    align-items: center;
    i{
      font-size: 14px;
      margin-left: 20px;
      margin-right: 10px;
    }
    span{
      @include font-primary(12px, regular)
    }
  }
  .menu-theme-general{
    .breadcrumb-faq{
      padding-left: 20px !important;
    }
  }
  @media only screen and (max-width: 897px) {
    .themes{
    height: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/faq/faq.vue